import { render, staticRenderFns } from "./VehicleDashboardTab.vue?vue&type=template&id=179eb66a&scoped=true"
import script from "./VehicleDashboardTab.vue?vue&type=script&lang=js"
export * from "./VehicleDashboardTab.vue?vue&type=script&lang=js"
import style0 from "./VehicleDashboardTab.vue?vue&type=style&index=0&id=179eb66a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179eb66a",
  null
  
)

export default component.exports